// extracted by mini-css-extract-plugin
export var header = "_gt-0";